import MessageFormat from "@messageformat/core"

export function formatVars(lang, msgSrc, placeholderValues) {
  const mf = new MessageFormat(lang)
  const msg = mf.compile(msgSrc)

  return msg(placeholderValues)
}

export function formatWithDateTime(lang, msgSrc, date, extraVars) {
  const dateFormatter = new Intl.DateTimeFormat(lang, {
    year: "numeric",
    month: "short",
    day: "numeric",
  })

  const timeFormatter = new Intl.DateTimeFormat(lang, {
    hour: "numeric",
    minute: "numeric",
  })

  return formatVars(lang, msgSrc, {
    DATE: dateFormatter.format(date),
    TIME: timeFormatter.format(date),
    ...extraVars,
  })
}
